module.exports = __webpack_public_path__ + "static/media/fon.2f12891c.jpg";